import { cardIssuersConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewCardIssuer = (state = initialState, action) => {
  switch (action.type) {
    case cardIssuersConstants.VIEW_CARDISSUER_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case cardIssuersConstants.VIEW_CARDISSUER_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardIssuersConstants.VIEW_CARDISSUER_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case cardIssuersConstants.VIEW_CARDISSUER_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
